import { format, isValid, parseISO } from "date-fns";

export const formatDateMMDDYYYY = (isoDate) => {
  if (!isoDate) return "";

  const parsed = parseISO(isoDate);
  const date = isValid(parsed) ? parsed : new Date(isoDate);
  return isValid(date) ? format(date, "MM-dd-yyyy") : "";
};

// "ON_HOLD" / "interview_invitation" -> "On Hold" / "Interview Invitation"
export const snakeToStartCase = (value) =>
  String(value ?? "")
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const buildCandidateJobLink = (token) =>
  `${String(import.meta.env.VITE_CANDIDATE_URL ?? "").replace(/\/$/, "")}/job-application/${token}`;
export const toCamelCase = (key) =>
  String(key).replace(/[:_\s-]+(\w)/g, (_, char) => char.toUpperCase());
